/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import {
  REPLACE_CLIPS,
  SET_SELECTION,
  STOP_SELECTION_DRAGGING,
} from "constants/ActionTypes";
import { SelectionAction } from "types/Actions";
import { AssetId } from "@phonos/types";
import { BlockToken } from "types/Block";
import { ClipId } from "types/Clip";

export const EMPTY_SELECTION = {
  clipIds: [],
  tokens: {},
};

export interface SelectionState {
  clipIds: ClipId[];
  mouseDownStartTime?: number;
  mouseDownEndTime?: number;
  startTime?: number;
  endTime?: number;
  tokens: Record<AssetId, BlockToken[]>;
}

export default function SelectionReducer(
  selection: SelectionState,
  action: SelectionAction
): SelectionState {
  switch (action.type) {
    case SET_SELECTION:
      return action.selection;
    case REPLACE_CLIPS:
      return EMPTY_SELECTION;
    case STOP_SELECTION_DRAGGING:
      return {
        ...selection,
        mouseDownEndTime: undefined,
        mouseDownStartTime: undefined,
      };
    default:
      return selection;
  }
}
